// Scroll-triggered fade-up animations
const observer = new IntersectionObserver(
  entries => entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('visible'); }),
  { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
);
document.querySelectorAll('.fade-up').forEach(el => observer.observe(el));

// AJAX add-to-cart for product card buttons
document.querySelectorAll('.btn-add').forEach(btn => {
  const form = btn.closest('form');
  if (!form) return;
  form.addEventListener('submit', function(e) {
    e.preventDefault();
    const orig = btn.textContent;
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(r => r.json())
      .then(() => {
        btn.textContent = 'Added ✓';
        btn.style.background = 'var(--orange-dark)';
        return fetch('/cart.js');
      })
      .then(r => r.json())
      .then(cart => {
        const counter = document.getElementById('cart-count');
        if (counter) counter.textContent = cart.item_count;
        setTimeout(() => { btn.textContent = orig; btn.style.background = ''; }, 1800);
      })
      .catch(() => form.submit());
  });
});
